export default "__VITE_ASSET__BqkH0s$A__"